<template>
  <div
    class="data-table rel mvh-40 mb-xl"
    :class="[
      $device === 'mobile' ? 'mx-l' : 'mx-3xl',
      loadingOrders ? 'loading' : '',
      locale == 'HE' ? 'rtl' :''
    ]"
  >
    <!-- <h3 class="data-table--title">My Orders</h3> -->
    <preloader v-if="loadingOrders" v-bind:title="localize('loading_orders')"></preloader>
    <div v-else class="over-auto">
      <ul v-if="$device === 'mobile'">
        <li
          :class="['mb-l', itemIsMinimized(i) ? 'minimized' : '']"
          v-for="(row, i) in renderedList"
          :key="row.WO_ID"
        >
          <p class="header" @click="toggleMinimizeRow(i)">
            <i
              class="far mx-s"
              :class="[
                itemIsMinimized(i) ? 'fa-chevron-up' : 'fa-chevron-down'
              ]"
            ></i>
            <strong>{{localize('order_no')}}</strong>
            <router-link
              class="text-gray-0"
              :to="
                `${userType === 3 || row.IsDraft ? 'order' : 'order-review'}/${
                  row.WO_ID
                }`
              "
            >
              <span v-text="row.WO_ID"></span>
            </router-link>
            <i
              @click="sortData('WO_ID')"
              :class="['sort-icon', 'ml-xs', 'fad', sortIconClass('WO_ID')]"
            ></i>
          </p>
          <p @click="sortData('Order_header')">
            <strong class="mr-s">
              <i
                :class="[
                  'mx-xs',
                  'fad',
                  'sort-icon',
                  sortIconClass('Order_header')
                ]"
              ></i>

              <span>{{localize('order_title')}}:</span></strong
            >
            <span v-text="row.Order_header"></span>
          </p>
          <p @click="sortData('StatusID')">
            <strong class="mr-s">
              <i
                :class="[
                  'mx-xs',
                  'fad',
                  'sort-icon',
                  sortIconClass('StatusID')
                ]"
              ></i>

              <span>{{localize('order_status').toUpperCase()}}:</span></strong
            >            
            <span
              :class="[row.StatusID === 7 ? 'text-red-4' : '']"
              v-text="statusNameById(row.StatusID)"
            ></span>
          </p>
          <p @click="sortData('Order_date')">
            <strong class="mr-s">
              <i
                :class="[
                  'mx-xs',
                  'fad',
                  'sort-icon',
                  sortIconClass('Order_date')
                ]"
              ></i>
              <span>{{localize('date_created').toUpperCase()}}:</span></strong
            >
            <span v-text="parseDate(row.Order_date)"></span>
          </p>
          <p @click="sortData('Actual_implant_date')">
            <strong class="mr-s">
              <i
                :class="[
                  'mx-xs',
                  'fad',
                  'sort-icon',
                  sortIconClass('Actual_implant_date')
                ]"
              ></i>

              <span>{{localize('surgery_date').toUpperCase()}}:</span>
            </strong>
            <span v-text="parseDate(row.Actual_implant_date)"></span>
          </p>
          <p @click="sortData('DoctorLastName')">
            <strong class="mr-s">
              <i
                :class="[
                  'mx-xs',
                  'fad',
                  'sort-icon',
                  sortIconClass('DoctorLastName')
                ]"
              ></i>

              <span>{{localize('dentisis_name').toUpperCase()}}</span>
            </strong>
            <span v-text="`Dr. ${row.DoctorLastName}`"></span>
          </p>
          <p @click="sortData('Cust_name')">
            <strong class="mr-s">
              <i
                :class="[
                  'mx-xs',
                  'fad',
                  'sort-icon',
                  sortIconClass('Cust_name')
                ]"
              ></i>
              <span>{{localize('patient_id').toUpperCase()}}:</span>
            </strong>
            <span v-text="row.Cust_name"></span>
          </p>
          <p @click="sortData('McenterName')">
            <strong class="mr-s">
              <i
                :class="[
                  'mx-xs',
                  'fad',
                  'sort-icon',
                  sortIconClass('McenterName')
                ]"
              ></i>
              <span>{{localize('mcenter').toUpperCase()}}:</span>
            </strong>
            <span v-text="row.McenterName || localize('Unavailable')"></span>
          </p>
          <p @click="sortData('MSOFT_CASE_NO')">
            <strong class="mr-s">
              <i
                :class="[
                  'mx-xs',
                  'fad',
                  'sort-icon',
                  sortIconClass('MSOFT_CASE_NO')
                ]"
              ></i>
              <span>{{localize('msoft_case_no').toUpperCase()}}:</span>
            </strong>
            <span v-text="row.MSOFT_CASE_NO || localize('Unavailable')"></span>
          </p>
          <p>
            <strong class="mr-s">{{localize('progress')}}:</strong>
            <progress-circle v-if="!row.IsDraft" :percent-complete="percentCompleted(row.StatusID)"></progress-circle>
          </p>
        </li>
      </ul>
      <table v-else width="100%" border="0" cellspacing="0" cellpadding="0">
        <thead>
          <tr :class="[allItemsSelected ? 'selected' : '']">
            <th :class="['row-select']">
              <span
                v-if="allowAllItemsSelect"
                @click="allItemsSelected = !allItemsSelected"
              ></span>
            </th>
            <th @click="sortData('WO_ID')">
              <span>
                <i
                  :class="['mx-xs', 'fad', 'sort-icon', sortIconClass('WO_ID')]"
                ></i>
                <span>{{localize('order_no')}}</span>
              </span>
            </th>
            <th @click="sortData('Order_header')">
              <span>
                <i
                  :class="[
                    'mx-xs',
                    'fad',
                    'sort-icon',
                    sortIconClass('Order_header')
                  ]"
                ></i>
                <span>{{localize('order_title')}}</span>
              </span>
            </th>
            <th @click="sortData('StatusName')">
              <span>
                <i
                  :class="[
                    'mx-xs',
                    'fad',
                    'sort-icon',
                    sortIconClass('StatusName')
                  ]"
                ></i>
                <span>{{localize('order_status')}}</span>
              </span>
            </th>
            <th @click="sortData('Order_date')">
              <span>
                <i
                  :class="[
                    'mx-xs',
                    'fad',
                    'sort-icon',
                    sortIconClass('Order_date')
                  ]"
                ></i>
                <span>{{localize('date_created')}}</span>
              </span>
            </th>
            <th @click="sortData('Actual_implant_date')">
              <span>
                <i
                  :class="[
                    'mx-xs',
                    'fad',
                    'sort-icon',
                    sortIconClass('Actual_implant_date')
                  ]"
                ></i>
                <span>{{localize('surgery_date')}}</span>
              </span>
            </th>
            <th @click="sortData('DoctorLastName')">
              <span>
                <i
                  :class="[
                    'mx-xs',
                    'fad',
                    'sort-icon',
                    sortIconClass('DoctorLastName')
                  ]"
                ></i>
                <span>{{localize('dentisis_name')}}</span>
              </span>
            </th>
            <th @click="sortData('Cust_name')">
              <span>
                <i
                  :class="[
                    'mx-xs',
                    'fad',
                    'sort-icon',
                    sortIconClass('Cust_name')
                  ]"
                ></i>
                <span>{{localize('patient_id')}}</span>
              </span>
            </th>
            <!-- <th>FORM TYPE</th> 
            <th @click="sortData('McenterName')">
              <span>
                <i
                  :class="[
                    'mr-xs',
                    'fad',
                    'sort-icon',
                    sortIconClass('McenterName')
                  ]"
                ></i>
                <span>{{localize('mcenter').toUpperCase()}}</span>
              </span>
            </th>-->
            <th @click="sortData('MSOFT_CASE_NO')">
              <span>
                <i
                  :class="[
                    'mx-xs',
                    'fad',
                    'sort-icon',
                    sortIconClass('MSOFT_CASE_NO')
                  ]"
                ></i>
                <span>{{localize('msoft_case_no')}}</span>
              </span>
            </th>
            <th class="tcenter">{{localize('progress')}}</th>
          </tr>
        </thead>

        <transition-group
          v-if="renderedList.length"
          v-bind:css="false"
          ref="list"
          name="list"
          tag="tbody"
          @before-enter="beforeEnter"
          @enter="enter"
          @leave="leave"
          appear
        >
          <tr
            @click="canSelectRow(row) && selectRow(row.WO_ID)"
            v-for="(row, i) in renderedList"
            :key="row.WO_ID"
            :class="[
              isSelected(row.WO_ID) ? 'selected' : '',
              row.IsDraft ? 'is-draft' : '',
              row.StatusID === 7 ? 'on-hold' : '',
              row.HasBlockedFiles === true ? 'blocked-files' : ''
            ]"
            v-tooltip.bottom-start="{content: row.IsDraft ? null : null}"
          >

            <td :class="['row-select']">

              <span v-if="canSelectRow(row)"></span>
              <span class="draft-delete" v-if="row.IsDraft" 
                  @click="deleteDraft(row.WO_ID)">
                <i class="far fa-trash-alt"></i>
              </span>
            </td>

            <td>
              <router-link
                :to="
                  `${
                    userType === 3 || row.IsDraft ? 'order' : 'order-review'
                  }/${row.WO_ID}`
                "
              >
                <span v-text="row.WO_ID"></span>
              </router-link>
              <v-popover v-if="row.Comment">
                <i
                  :title="localize('click_for_annotation')"
                  class="fal fa-comment-alt-dots ml-xs notes-button"
                ></i>
                <!-- <button>Click me</button> -->

                <template slot="popover">
                  <i class="fal fa-times close-icon" v-close-popover></i>
                  <div>
                    <h4>{{localize('annotation')}}</h4>
                    <p v-text="row.Comment"></p>
                  </div>
                </template>
              </v-popover>
              <!-- v-tooltip.bottom-right="{
                  class: 'notes',
                  content: 'Click For Annotations'
                }" -->
            </td>
            <td>
              <span v-text="row.Order_header"></span>
            </td>
            <td>
              <!-- <span
                v-if="isDistributor"
                v-text="statusById(row.StatusID)"
              ></span> -->              
              <select
                @change="statusChanged($event, row)"
                class="select-inline"
                name=""
                :id="`statusSelect_${i}`"
                v-if="statusInRestrictedList(row.StatusID)"
              >
                <option
                  :key="status.id"
                  :selected="row.StatusID == status.id"
                  v-for="status in restrictedStatusList(row.StatusID)"
                  :value="status.id">
                  {{ localize(status.StatusDesc) }}
                </option>
              </select>
              <span
                class="note text-gray-8"
                v-else
                v-text="statusNameById(row.StatusID)"
              ></span>
            </td>
            <td>
              <span v-text="parseDate(row.Order_date)"></span>
            </td>
            <td>
              <span v-text="parseDate(row.Actual_implant_date)"></span>
            </td>
            <td>
              <span
                v-if="row.DoctorLastName"
                v-text="`Dr. ${row.DoctorLastName}`"
              ></span>
              <span v-else>N/A</span>
            </td>
            <td>
              <span v-text="row.Cust_name"></span>
            </td>
            <!--<td><span v-text="row.McenterName || 'Unavailable'"></span></td>-->
            <td class="rel">
              <span v-if="!isMcenter" v-text="row.MSOFT_CASE_NO || localize('Unavailable')"></span>
              <form-field
                v-else
                v-model="row.MSOFT_CASE_NO"
                inline
                @focus="rowMSoftFocus"
                @blur="rowMSoftBlur"
                label="MSOFT #"
                label-is-placeholder
                class="pl-0 m-0"
                :class="orderSavingMSOFT === row.WO_ID ? 'in-saving' : ''"
              ></form-field>
              <i
                @click="saveMSOFTCaseNumber(row)"
                v-tooltip.bottom-start="'Save MSOFT Case Number'"
                :class="[
                  'far',
                  'focus-btn',
                  'inl',
                  !row.MSOFT_CASE_NO ? 'disabled' : '',
                  orderSavingMSOFT === row.WO_ID
                    ? 'fa-spin fa-spinner'
                    : 'fa-check'
                ]"
              >
              </i>
            </td>
            <td class="tcenter no-sort">
                <!-- APPROVE ORDER BUTTON {{row.WO_ID}} 5000413 -->     

                <!-- Edit order button  -->
                <template v-if="isOrderHasBlockedFiles(row)">
                  <div @click.stop="gotoEditPage(row)" class="approveBtn"> {{localize('edit_order')}}</div>
                </template>
                <template v-else-if="isItemNeedApproval(row) && !isItemApproved(row)">                  
                  <div @click.stop="gotoApprovalPage(row)"  class="approveBtn"> {{localize('approve')}}</div>
                </template>
                <!-- PROGRESS CIRCLE -->
                <template v-else>
                  <progress-circle v-if="!row.IsDraft" :percent-complete="percentCompleted(row.StatusID)"></progress-circle>
                </template>
            </td>
          </tr>
        </transition-group>
      </table>
      <h4 class="no-show py-xl" v-if="!renderedList.length">
        <span>{{localize('no_orders_to_show')}}</span>
        <i class="fal fa-transporter-empty fa-2x mt-s"></i>
      </h4>
      <ul v-if="totalPages > 1" class="pager-bar flex align-center">
        <li @click="currentPage--" :class="{ disabled: currentPage === 0 }">
          <i class="fas fa-chevron-left"></i>
        </li>
        <li
          :class="['mx-xs', currentPage === i ? 'active' : '']"
          v-for="(page, i) in totalPages"
          :key="page"
          v-text="i + 1"
          @click="currentPage = i"
        ></li>
        <li
          @click="currentPage++"
          :class="{ disabled: currentPage === totalPages - 1 }"
        >
          <i class="fas fa-chevron-right"></i>
        </li>
      </ul>
    </div>



    <transition name="fade" appear>

      <!--
      <div  v-if="(allItemsSelected || selectedRows.length) && _isDraftsMode" class="flex align-center py-2xl">
        //Delete drafts
      </div>-->
      <div 
        v-if="
          (allItemsSelected || selectedRows.length) &&
            restrictedStatusList.length &&
            !_isDraftsMode 
        "
        class="flex align-center py-2xl"
      >
          <h5 class="mb-0">{{localize('apply_to_selected_orders')}}:</h5>
          <form-field
            :locale = "locale"
            :class="['maxw-200', 'flex-child', 'mb-0', 'ml-s', 'mr-s']"
            field-type="select"
            v-bind:select-placeholder="localize('choose_status')"
            :select-options="restrictedStatusList(-1)"
            select-label="StatusDesc"
            select-value="id"
            v-model="globalStatusChange"
            multi
            rounded
          ></form-field>
          <button
            @click="updateMultipleStatuses"
            class="flex align-center btn btn-primary rounded ml-s"
          >
            <preloader v-if="actionLoading" inline color="white"></preloader>
            <span>{{localize('submit')}}</span>
          </button>

      </div>
    </transition>
  </div>
</template>






<script>
import moment from "moment";
//  const moment = require('moment-business-days');
import { mapState, mapGetters, mapActions } from "vuex";
import ProgressCircle from "@/components/ProgressCircle.vue";
import TeethChart from './TeethChart.vue';
export default {
  props: {
    info: Object,
    list: Array
  },
  components: {
    ProgressCircle
  },
  data() {  
      return {
      _isDraftsMode:false,
      itemsPerPage: 12,
      actionLoading: false,
      globalStatusChange: null,
      allItemsSelected: false,
      selectedRows: [],
      // For mobile >>
      minimizedRows: [],
      // For mobile <<
      sort: {
        labels: ["Order_date"],
        directions: ["desc"]
      },
      currentPage: 0,
      orderSavingMSOFT: null
      // pager: {
      //   totalPages:
      // }
      // paginate: ["sortedList"]
    };
  },
  watch: {
    allItemsSelected() {
      if (this.allItemsSelected) {
        this.selectedRows = [];
      }
    },
    totalPages() {
      if (this.currentPage > this.totalPages - 1) {
        this.currentPage = Math.max(this.totalPages - 1, 0);
      }
    }
  },
  mounted() {
    console.log("ENV", ENV);
  },
  computed: {
    ...mapState([
      "locale",
      "user",
      "loadingOrders",
      "filters",
      "statusFilter",
      // "typeFilter",
      "statusList",
      "$device"
    ]),
    ...mapGetters([
      "minDate",
      "orderStatusList",
      "userType",
      "userToken",
      "userID",
      "isMcenter",
      "isDistributor",
      "isDoctor"
    ]),
    totalPages() {
      return Math.ceil(this.sortedList.length / this.itemsPerPage);
    },
    allowAllItemsSelect() {
      return !!_.filter(this.renderedList, item => {
        return item.StatusID === 2;
      }).length;
    },
    statusTotal() {
      return this.orderStatusList.length;
    },
    filteredList() {
      // console.log("MOMENT: ", moment);
      let l = this.list;
      let f = this.filters;
      let s = this.statusFilter;
      // let t = this.typeFilter;
      let from = f.fromDate ? moment(f.fromDate).format("YYYY-MM-DD") : null;
      let to = f.toDate ? moment(f.toDate).format("YYYY-MM-DD") : null;
      let search = f.searchText;

      l = _.filter(l, item =>
        moment(moment(item.Order_date).format("YYYY-MM-DD")).isSameOrAfter(
          this.minDate
        )
      );


      if (s) {
        l = _.filter(l, item => item.StatusID === s);
      }
      if (from || to) {
        l = _.filter(l, item => {
          let date = moment(item.Order_date).format("YYYY-MM-DD");
          return from && to
            ? moment(date).isBetween(moment(from), moment(to), null, "[]")
            : from && !to
            ? moment(date).isSameOrAfter(from)
            : moment(date).isSameOrBefore(to);
        });
      }
      if (search) {
        l = _.filter(l, item => {
          let rawVal = _.values(item)
            .join("")
            .toLowerCase();
          return rawVal.indexOf(search.toLowerCase()) > -1;
        });
      }
      return l;
    },
    sortedList() {
      let list = this.filteredList;
      let sort = this.sort;
      // if (this.isMcenter) {
      //   for (var i = 0; i < list.length; i++) {
      //     list[i].msoftACTIVE = false;
      //   }
      // }
      return _.orderBy(list, sort.labels, sort.directions);
    },
    renderedList() {
      let list = this.sortedList;
      if (list && list.length) 
      {
        let per = this.itemsPerPage;
        let fromIndex = per * this.currentPage;
        let toIndex = fromIndex + this.itemsPerPage;

        /* 
      if page 1 for example
      per = 12
      need to return index 12 - 23

*/
        return _.filter(list, (item, i) => fromIndex <= i && toIndex > i);
      }
      return [];
    }
  },

  methods: {
    ...mapActions(["initOrdersList"]),
    deleteDraft(id)
    {
        let vm = this;
        let postURL = `${SERVER_API[ENV]}mflow/DraftDel?order_id=${id}`;
        return fetch(postURL, {
          method: "POST",headers: { t: this.userToken, u: this.userID }
        })
        .then(res => res.json())
        .then(response => {
          vm.initOrdersList();
          //console.log("delete draft response  >> ", response);
          //vm.$emit("reload");//reload the list of orders
          //if (response === "ok") {
        });
    },
    saveMSOFTCaseNumber: _.debounce(function(order) 
    {
      let vm = this;
      let postURL = `${SERVER_API[ENV]}mflow/OrderChangeMsoftCase?order_id=${order.WO_ID}&msoft_case_no=${order.MSOFT_CASE_NO}`;
      this.orderSavingMSOFT = order.WO_ID;

      fetch(postURL, 
      {
        method: "POST",
        headers: { t: this.userToken, u: this.userID }
      })
        .then(res => res.json())
        .then(response => {
          if (response === "ok") {
            vm.$toasted.show("MSOFT Case number change successfully", {
              position: "bottom-center",
              type: "success",
              theme: "bubble",
              icon: {
                name: "fal fa-check-circle mr-xs"
              }
            });
            vm.orderSavingMSOFT = null;
          } else {
            vm.$toasted.show("Something went wrong.. please try again", {
              position: "bottom-center",
              type: "warning",
              theme: "bubble",
              icon: {
                name: "fal fa-exclamation-circle mr-xs"
              }
            });
          }
          vm.orderSavingMSOFT = null;
        })
        .catch(err => {
          vm.orderSavingMSOFT = null;
          return err;
        });
    }, 300),
    rowMSoftFocus: _.debounce(function(el) {
      el.classList.add("in-focus");
    }, 300),
    rowMSoftBlur: _.debounce(function(el) {
      el.classList.remove("in-focus");
    }, 300),
    // FOR MOBILE
    toggleMinimizeRow(_index) {
      let i = this.minimizedRows.indexOf(_index);
      if (i > -1) {
        // maximize
        this.minimizedRows.splice(_index, 1);
      } else {
        this.minimizedRows.push(_index);
      }
    },
    itemIsMinimized(_index) {
      return this.minimizedRows.indexOf(_index) > -1;
    },
    beforeEnter: function(el) {
      el.style.opacity = 0;
      el.style.transform = "translateY(80%)";
    },
    enter: function(el, done) {
      let lapse = 180,
        delay = el.dataset.index * lapse;
      setTimeout(function() {
        el.animate(
          {
            opacity: [0, 1],
            transform: ["translateY(80%)", "translateY(0)"],
            easing: "cubic-bezier(0.175, 0.885, 0.32, 1.275)"
          },
          { duration: 600, fill: "forwards" }
        ).onfinish = function() {
          done();
        };
      }, delay);
    },
    leave: function(el, done) {
      el.style.opacity = 0;
      el.style.transform = "translateY(120%)";
      done();
    },
    statusNameById(id) {
      let list = this.statusList;
      let s = _.find(list, { id });
      if (s) {
        return this.localize(s.StatusDesc);
      }
      return null;
    },
    updateMultipleStatuses() {
      let vm = this;
      let order_ids = this.selectedRows.length
        ? this.selectedRows
        : _.map(this.list, "WO_ID");
      var postParams = {
        ststus_id: this.globalStatusChange,
        order_ids
      };

      var body = JSON.stringify(postParams);

      var postURL = `${SERVER_API[ENV]}mflow/OrderChangeStatusBulk`;
      this.actionLoading = true;
      fetch(
        postURL,

        {
          body,
          method: "POST",
          headers: { t: this.userToken, u: this.userID }
        }
      )
        .then(res => res.json())

        .then(res => {
          vm.actionLoading = false;

          if (res === "ok") {
            vm.$toasted.show("Order Statuses changed successfully", {
              position: "top-center",
              // iconPack: "fontawesome",
              type: "success",
              theme: "bubble",
              icon: {
                name: "fal fa-check-circle mr-xs"
              }
            });
            vm.selectedRows = [];
            vm.allItemsSelected = false;
            vm.initOrdersList();
          } else {
            vm.$toasted.show("Something went wrong.. please try again", {
              position: "bottom-center",
              // iconPack: "fontawesome",
              type: "warning",
              theme: "bubble",
              icon: {
                name: "fal fa-exclamation-circle mr-xs"
              }
            });
          }
        })
        .catch(err => console.log("err>", err));
    },
    statusChanged(e, order) {
      let vm = this;
      // console.log("status changed >> ", order, " :: ", e.target.value);
      let id = e.target.value;
      let postURL = `${SERVER_API[ENV]}mflow/OrderChangeStatus?order_id=${order.WO_ID}&status_id=${id}`;
      fetch(postURL, {
        method: "POST",
        headers: { t: this.userToken, u: this.userID }
      })
        .then(res => res.json())
        .then(response => {
          // console.log("status changed >> ", response);
          if (response === "ok") {
            vm.$toasted.show("Order Status change successfully", {
              position: "bottom-center",
              // iconPack: "fontawesome",
              type: "success",
              theme: "bubble",
              icon: {
                name: "fal fa-check-circle mr-xs"
              }
            });
            vm.selectedRows = [];
            vm.initOrdersList(true);
            vm.allItemsSelected = false;
          } else {
            vm.$toasted.show("Something went wrong.. please try again", {
              position: "bottom-center",
              // iconPack: "fontawesome",
              type: "warning",
              theme: "bubble",
              icon: {
                name: "fal fa-exclamation-circle mr-xs"
              }
            });
          }
          // commit("SET_ORDERS_LIST", response);
        })
        .catch(err => err);
    },
    statusById(id) {
      let status = _.find(this.statusList, { id });
      if (status) {
        return status.StatusName;
      }
      return "";
    },
    isItemNeedApproval(item)
    {
      var vm=this;

      //if(item.WO_ID==5000389)
      //{
        //alert("IsOrderWaitingForApproval="+item.IsOrderWaitingForApproval);
        //alert("item.StatusID="+item.StatusID);
        //return true;
      //}

      //If one of these cases, do not show approve button: 
      //Canclled = 6 / Done = 8 / Shipped = 5
      if(item.StatusID === 5 || item.StatusID === 6 || item.StatusID === 8){
          return false;
      }

      return item.IsOrderWaitingForApproval; //logic on server

      //add on server logic property item.waitingForApproval (bool)
      //https://mflow-do-dev.mis-implants.com/mflow/OrdersList
      var needApproval = false;      
      if(item.StatusID == 21 && vm.user.IsPwsUser==true){
        needApproval=true;
      }
      if(item.StatusID == 2 && vm.user.IsPwsUser!=true){
        needApproval=true;
      }
      return needApproval;
    },
    isItemApproved(item)
    {
        let AlreadyApproved = false;
        if(item.DidDoctorApprove && item.DidDoctorApprove==true){
          AlreadyApproved=true;
        }
        return AlreadyApproved;
    },
    isOrderHasBlockedFiles(item)
    {
      let hasBlockedFiles = false;
      if(item.HasBlockedFiles && item.HasBlockedFiles==true){
        hasBlockedFiles=true;
      }
      return hasBlockedFiles;
    },
    gotoApprovalPage(item)
    {
        var routePath =  "/order/"+item.WO_ID+"/approval";
        this.$router.replace(routePath);        
    },
    gotoEditPage(item)
    {
        var routePath =  "/order/"+item.WO_ID;
        this.$router.replace(routePath);        
    },
    restrictedStatusList(statusId)
    {
      //GET THE RESTICTED LIST AND TRANSLATE IT
      let list = this.getRestrictedStatusList(statusId);
      for(let i=0;i<list.length;i++){
        list[i].StatusDesc = this.localize(list[i].StatusDesc);
      }
      return list;
    },
    getRestrictedStatusList(statusId) {
      // console.log("RESTIT >> ", statusId, this.userType);
      // return this.statusList;
      if (ENV === "dev") {
        return this.statusList;
      }
      let list = this.statusList,
        result;
      // By User Type, and current status...
      if (this.isDistributor) {
        // DISTRIBUTOR
        // console.log("statusId: ", statusId);
        if (statusId === 2 || -1) {
          result = _.filter(list, status => {
            return status.id === 3 || status.id === 2;
          });
          // console.log("result: ", result);
        } else {
          result = [];
        }
      }

      if (this.userType === 2) {
        // DOCTOR
        if (statusId < 0) {
          result = _.filter(list, status => {
            return (
              status.id === 1 ||
              status.id === 2 ||
              status.id === 3 ||
              status.id === 6 ||
              status.id === 7
            );
          });
        } else {
          result = _.filter(list, status => {
            if (statusId === 1 || statusId === 6 || statusId === 7) {
              return status.id === 1 || status.id === 6 || status.id === 7;
            } else if (statusId === 2 || statusId === 3) {
              return status.id === 2 || status.id === 3;
            }
          });
        }
      }
      // console.log("restricted list > ", result);
      return result || list;
    },
    statusInRestrictedList(id) {
      let list = this.restrictedStatusList(id);
      // console.log("list: ", list);

      // DOCTORS IN PRODUCTION, no status change option.
      if (ENV === "prod" && this.isDoctor) {
        return 0;
      }
      return !!_.filter(list, { id }).length;
      // console.log("length: ", length);
      // return !!list.length;
    },
    sortData(label) {
      let d = this.sort.directions;
      let l = this.sort.labels;
      let i = l.indexOf(label);
      let currentDirection;
      if (i > -1) {
        // Label is already sorted.. check direction
        currentDirection = d[i];
        if (currentDirection === "desc") {
          // If Descending, change to Ascending
          this.$set(d, i, "asc");
        } else {
          // If Ascending, remove sort from label
          d.splice(i, 1);
          l.splice(i, 1);
        }
      } else {
        l.push(label);
        d.push("desc");
      }
    },
    sortIconClass(label) {
      let d = this.sort.directions;
      let l = this.sort.labels;
      let i = l.indexOf(label);
      if (i > -1) {
        if (d[i] === "desc") {
          return "fa-sort-up";
        }
        return "fa-sort-down";
      }
      return "fa-sort";
    },
    percentCompleted(id) {
      let index = _.findIndex(this.orderStatusList, { id }) + 1;
      if (index) {
        return (index / this.statusTotal) * 100;
      }
      return 0;
    },
    isSelected(id) {
      return this.allItemsSelected || this.selectedRows.indexOf(id) > -1;
    },
    canSelectRow(row)
    {
        return row.StatusID === 2 && !row.IsDraft ? true : false; // || row.IsDraft
    },
    isDraftsMode()
    {      
        var draftsMode = false;
        if(this.renderedList.length>0){
          draftsMode = this.renderedList[0].IsDraft == true ? true : false;
        }
        this._isDraftsMode=draftsMode;
        return draftsMode;
    },
    selectRow(id) 
    {
      //check first if in drafts mode
      var draftsMode = false;
      if(this.renderedList.length>0){
        draftsMode = this.renderedList[0].IsDraft == true ? true : false;
      }
      this._isDraftsMode = draftsMode;        

      this.allItemsSelected = false;
      let index = this.selectedRows.indexOf(id);
      if (index > -1) {
        this.selectedRows.splice(index, 1);
      } else {
        this.selectedRows.push(id);
      }
    },
    parseDate(string, withTime) {
      let d = new Date(string);
      if (withTime) {
        return `${d.getDate()}/${d.getMonth() +
          1}/${d.getFullYear()} @${d.getHours()}:${("0" + d.getMinutes()).slice(
          -2
        )}`;
      }
      return `${d.getDate()}/${d.getMonth() + 1}/${d.getFullYear()}`;
    }
  }
};
</script>

/* FOCUS BUTTON */
<style lang="stylus">
.focus-btn
  round(20)
  display none
  padding 0 !important
  background green_4
  color #fff
  position absolute
  top 50%
  transform translateY(-75%)
  right 0
  font-size 75%
  line-height 22px
  text-align center
  cursor pointer
  transition background 0.3s ease-out
  &:hover
    background green_3
.in-focus
.in-saving
  position relative
  & + .focus-btn
    display block
    z-index 99999
    &.disabled
      background rgba(green_4, 0.4)
      pointer-events none
.in-saving + .focus-btn
  margin-top -13% !important
</style>

/* ROW SELECT */
<style lang="stylus">
.draft-delete
  border 0px !important
  i
    cursor pointer
.row-select
  // _flex(row, wrap, center,center)
  text-align center
  line-height 20px
  span
    width 20px
    height 20px
    display block
    border 1px solid blue_brand
    /.selected &
      background blue_brand
</style>

<style>
  .data-table.rtl table thead tr th
  {
    text-align:right;
  }
</style>
/ * DATATABLE */
<style lang="stylus">
.data-table
  &.loading
    background rgba(blue_brand, 0.1)
  &.short tbody
    max-height 200px !important
  // mobile view
  & > div > ul
    li
      background gray_2
      overflow hidden
      transition max-height 0.3s ease-out-quad
      max-height 500px
      &.minimized
        max-height 40px
      & > p
        _flex(row, wrap, center, flex-start)
        // marg('l', bottom)
        padding 1px 2px
        border-bottom 1px solid blue_brand
        &:last-child
          border none
        & > strong
          flex 0 0 50%
          padding 8px 6px
          background rgba(blue_brand, 0.2)
          height 100%
        & > span:not(.progress-circle)
          padding 4px 2px
        &.header
          position relative
          background blue_brand
          color #fff
          display block
          line-height 40px
          strong
            background none
          .sort-icon
            position absolute
            top 50%
            transform translateY(-50%)
            right 5%
  table
    min-width 1200px
    width 100%
    border-bottom 1px solid gray_4
    position relative
    &:after
      content ''
      width 100%
      position absolute
      bottom 0
      left 0
      height 10px
      background linear-gradient(to top, rgba(#fff, 0.5), rgba(#fff, 0))

    tbody
    thead
      display block
      width 100%
      tr
        display table
        width 100%
        table-layout fixed
        .row-select
          width 60px
    thead
      position relative
      z-index 1
      &:before
        content ''
        pointer-events none
        background linear-gradient(to bottom, rgba(#fff, 0.5) , rgba(#fff, 0))
        width 100%
        position absolute
        left 0
        bottom -10px
        height 10px
      tr
        th
          height 70px
          border-top 0px solid gray_5
          border-bottom 1px solid gray_3
          padding 8px 4px
          text-align left
          color blue_brand
          font-size 14px
          text-transform uppercase
          font-weight 500
          .sort-icon
            width 10px
          &.row-select
            pad('s', x)
          & > span
            _flex(row, nowrap, center, flex-start)
            line-height 1
            *
              font-weight 500

    tbody
      max-height 400px
      overflow-y scroll
      position relative
      tr
        &:hover
          background rgba(green_1, 0.15)
        &.is-draft
          background rgba(yellow_1, 0.15)
        &.on-hold
          background rgba(red_1, 0.15)
        &.blocked-files
          background rgba(red_1, 0.25)          
        &.selected
          background rgba(green_1, 0.25)
        td
          height 60px
          color gray_6
          padding 0 10px
          span
            font-size 14px
            font-weight 400
          & > *:not(.progress-circle)
            marg('xs', left) !important
            padding-left 8px
            font-weight 400
          .notes-button
            color green_4
            font-size 80%
            cursor pointer
            &:hover
              color green_3
          &.row-select
            pad('s', x)
          +desktop()
            a:hover
              text-decoration underline

&.no-show
  _flex(column, wrap, center, center)

  min-height 10vh
  text-align center
  font-size 20px
  font-weight 400
.pager-bar
  pad('s', y)
  li
    width 20px
    height @width
    line-height @width
    margin 0 2px 0 0
    text-align center
    // border-radius 2px
    border-radius 10px
    transition background 0.3s ease-out
    cursor pointer
    color blue_brand
    font-size 13px
    &.disabled
      opacity 0.7
      pointer-events none
    i
      transition opacity 0.3s ease-out
      opacity 0.5
    &:hover
      i
        opacity 1
    a
      transition color 0.3s ease-out
    &.active
      cursor default
      background blue_brand
      color #fff
      font-size 14px
</style>


<style lang="css" scoped>
  .approveBtn
  {
    background-color: #0076c0;
    font-size: 11px;
    color:#fff;    
    display: inline;
    padding: 2px 12px;
    position: relative;
    top: 3px;
    font-weight: 500;
    cursor: pointer;
  }
  .approveBtn:hover
  {
    color:#fff !important;
    background-color: #1c87cf !important;
  }
</style>
